"use client";

import { useState } from "react";
import { ChevronDown } from "lucide-react";

export type FaqItem = { question: string; answer: string };

/** The same card-per-question accordion the project page uses. */
export function FaqAccordion({ items }: { items: FaqItem[] }) {
  const [active, setActive] = useState<number | null>(null);
  return (
    <div className="space-y-3">
      {items.map((item, index) => {
        const open = active === index;
        return (
          <div key={item.question} className="overflow-hidden rounded-2xl border border-line bg-white">
            <button
              type="button"
              onClick={() => setActive(open ? null : index)}
              aria-expanded={open}
              className="flex w-full items-center justify-between gap-4 p-5 text-left font-medium text-ink focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-brand-500"
            >
              <span>{item.question}</span>
              <ChevronDown aria-hidden="true" className={`size-5 shrink-0 text-ink-muted transition-transform ${open ? "rotate-180" : ""}`} />
            </button>
            <div className={`grid transition-[grid-template-rows,opacity] duration-200 ${open ? "grid-rows-[1fr] opacity-100" : "grid-rows-[0fr] opacity-0"}`}>
              <div className="overflow-hidden">
                <p className="px-5 pb-5 text-sm leading-6 text-ink-muted">{item.answer}</p>
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
}
